import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles<Theme>((theme) => ({
  dialogTitle: {
    display: "flex",
    padding: "16px 24px",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
  },
  dialogTextContainer: {
    display: "flex",
    padding: "0 24px 20px 24px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    alignSelf: "stretch",
  },
  dialogText: {
    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    letterSpacing: "0.15px",
    padding: "0px",
  },
  dialogActions: {
    "& > *": {
      color: "var(--primary-main, #2196F3)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "0.4px",
      textTransform: "uppercase",
    },
  },
}));

export default useStyles;
